import { render, staticRenderFns } from "./CampaignChaptersTable.vue?vue&type=template&id=335f171c&scoped=true&"
import script from "./CampaignChaptersTable.vue?vue&type=script&lang=js&"
export * from "./CampaignChaptersTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignChaptersTable.vue?vue&type=style&index=0&id=335f171c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335f171c",
  null
  
)

export default component.exports